var config = require("./config.global");

config.backend_domain = "https://api.financefirst.app";
config.authentication_user_pool_id = "us-east-1_pvhYR6UwB";
config.authentication_client_id = "7vg3ug89cbg0rudodc08i96pn2";

module.exports = config;
